import { useAccount, useSwitchChain } from 'wagmi';
import { useTranslation } from 'react-i18next';
import { BSC_CHAIN_ID } from '../../lib/addresses';

const ChainGuard = ({ children }) => {
  const { t } = useTranslation();
  const { chainId, isConnected } = useAccount();
  const { switchChain, isPending } = useSwitchChain();

  if (!isConnected || !chainId || chainId === BSC_CHAIN_ID) {
    return children;
  }

  return (
    <div className="db-chain-guard">
      <div className="db-chain-guard__card">
        <div className="db-chain-guard__icon">
          <i className="fas fa-exclamation-triangle" />
        </div>
        <h3>{t('dashboard.wrongChain.title')}</h3>
        <p>{t('dashboard.wrongChain.desc')}</p>
        <button
          type="button"
          className="sf-btn sf-btn--gold"
          onClick={() => switchChain({ chainId: BSC_CHAIN_ID })}
          disabled={isPending}
        >
          {isPending ? t('dashboard.wrongChain.switching') : t('dashboard.wrongChain.switch')}
        </button>
      </div>
    </div>
  );
};

export default ChainGuard;
